import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router'; 
import { CameraServerRoutingModule } from './camera-server-routing.module';
import { AddEditCameraListComponent } from './add-edit-camera-list/add-edit-camera-list.component';
import { AddEditSiteListComponent } from './add-edit-site-list/add-edit-site-list.component';
import { CameraListComponent } from './camera-list/camera-list.component';
import { CameraViewDialogComponent } from './dialogs/camera-view-dialog/camera-view-dialog.component';
import { DeviceDetailsDialogComponent } from './dialogs/device-details-dialog/device-details-dialog.component';
import { OutputsDetailsDialogComponent } from './dialogs/outputs-details-dialog/outputs-details-dialog.component';
import { StrobesDetailsDialogComponent } from './dialogs/strobes-details-dialog/strobes-details-dialog.component';
import { SiteListComponent } from './site-list/site-list.component';
import { FootageDownloadComponent } from './dialogs/footage-download/footage-download.component';
import { SiteCamLiveViewsComponent } from './dialogs/site-cam-live-views/site-cam-live-views.component';
import { ConfirmationDialogComponent } from './dialogs/confirmation-dialog/confirmation-dialog.component';
import { Ec2AddEditComponent } from './dialogs/ec2-add-edit/ec2-add-edit.component';
import { MoveSite } from './dialogs/move-site/move-site';
import { GetAllEc2Component } from './get-all-ec2/get-all-ec2.component';
import { MaskCamsComponent } from './masking/mask-cams/mask-cams.component';
import { MaskingComponent } from './masking/masking.component';
import { CancelSiteListComponent } from './cancel-site-list/cancel-site-list.component';
import { RtspUrlPlayerComponent } from './dialogs/rtsp-url-player/rtsp-url-player.component';
import { FootageQueueListComponent } from './footage-queue-list/footage-queue-list.component';
import { OwlDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../shared/material.module';
import { NgxPanZoomModule } from 'ngx-panzoom';
import { IframeModalComponent } from '../iframe-modal/iframe-modal.component';
import { ExportDeleteImportComponent } from './dialogs/export-delete-import/export-delete-import.component';


@NgModule({
  declarations: [
    SiteListComponent,
    AddEditSiteListComponent,
    CameraListComponent,
    AddEditCameraListComponent,
    CameraViewDialogComponent,
    DeviceDetailsDialogComponent,
    OutputsDetailsDialogComponent,
    StrobesDetailsDialogComponent,
    SiteCamLiveViewsComponent,
    FootageDownloadComponent,
    MaskingComponent,
    MaskCamsComponent,
    ConfirmationDialogComponent,
    Ec2AddEditComponent,
    MoveSite,
    CancelSiteListComponent,
    FootageQueueListComponent,
    RtspUrlPlayerComponent,
    ExportDeleteImportComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    NgxPanZoomModule,
    NgxPaginationModule,
    MaterialModule,
    OwlDateTimeModule,
    NgbModule,
    CameraServerRoutingModule,
    IframeModalComponent,  // Standalone component
    GetAllEc2Component
  ]
})
export class CameraServerModule { }
